import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import React, { useEffect, useState, useCallback, useRef } from 'react';
import { getUniqueKeys, getUniqueValues, parseData, subsetData } from '../utils/utils';
import { useSelector, useDispatch } from 'react-redux';
import { setItems } from '../redux/chooseItemsSlice';
import { setItemGroups } from '../redux/chooseItemGroupSlice';
import IndeterminateCheckBoxIcon from '@mui/icons-material/IndeterminateCheckBox';
import AddBoxIcon from '@mui/icons-material/AddBox';
import SearchIcon from '@mui/icons-material/Search';
import CancelIcon from '@mui/icons-material/Cancel';
import { IconButton, Tooltip } from '@mui/material';
import TextField from '@mui/material/TextField';
import {Divider} from '@mui/material';
import ReportIcon from '@mui/icons-material/Report';
import VisibilityIcon from '@mui/icons-material/Visibility';
import UpdateIcon from '@mui/icons-material/Update';


const ChooseFields = () => {
    
    const [keys, setKeys] = useState([])
    const [itemgroup, setitemgroup] = useState([])
    const [showSubgroup, setShowSubgroup] = useState([])
    const [showSearch, setShowSearch] = useState(false)
    const [showUsedItems, setShowUsedItems] = useState(false)

    const [filtered, setFiltered] = useState({})
    const [critical, setCritical] = useState({})
    const [showCritical, setShowCritical] = useState(false)

    const checkboxStates = useSelector(state => state.chooseItem.value)
    const data = useSelector(state => state.rawData.value)
    const groupChecked = useSelector(state => state.chooseItemGroup.value)
    const dateData = useSelector(state => state.dateData.value)
    const selectedDates = useSelector(state => state.chooseWeek.value)

    const dispatch = useDispatch()

    useEffect(() => {
        // filter dateData on the selected dates
        let filteredDates = []
        dateData.forEach((item) => {
            const dateTime = new Date(item.datum).getTime()            
            if (dateTime >= selectedDates.from && dateTime <= selectedDates.to){
                filteredDates.push(item)
            }
        })
    

        let temp = {}
        data.forEach((item) => {
            temp[item.TARIEFOMSCHRIJVING] = item.VRIJEVOORRAAD
            filteredDates.forEach((date) => {
                if (date.tariefomschrijving == item.TARIEFOMSCHRIJVING){
                    temp[item.TARIEFOMSCHRIJVING] -= date.aantal
                }
            })
        }
        )

        // for each item in temp look if the value is below 0, if not, throw it out
        for (const [key, value] of Object.entries(temp)) {
            if (value >= 0){
                delete temp[key]
            }
        }

        setCritical(temp)
        
    }, [data, dateData, selectedDates])




    // Set the keys from the data
    useEffect(() => {
        setKeys(getUniqueKeys(data))
    }, [data])

    // Set the itemgroups from the data
    useEffect(() => {
        setitemgroup(getUniqueValues(data, 'TARIEFGROEPOMSCHRIJVING'))
    }, [data])

    useEffect(() => {
        let temp = []
        itemgroup.forEach((item) => {
            temp.push(false)
        })
        setShowSubgroup(temp)
    }, [itemgroup])


    const  subgroupStyle = {
        marginLeft: "30px",
        display: 'block',

    }

    useEffect(() => {
        if (filtered.keys == null){
            resetFilter()
        }
    }, [])

    const resetFilter = () => {
        const ig = getUniqueValues(data, 'TARIEFGROEPOMSCHRIJVING')
        let temp = {}
        ig.forEach((ig) => {
            temp[ig] = {}
            subsetData(data, ig, 'TARIEFGROEPOMSCHRIJVING').forEach((item) => {
                temp[ig][item.TARIEFOMSCHRIJVING] = true
            })
        })
        setFiltered(temp)
    }


    const filter = (e) => {
        let grouptemp = []
        itemgroup.forEach((item) => {
            grouptemp.push(true)
        })
        setShowSubgroup(grouptemp)

        const ig = getUniqueValues(data, 'TARIEFGROEPOMSCHRIJVING')
        let temp = {}
        ig.forEach((ig) => {
            temp[ig] = {}
            subsetData(data, ig, 'TARIEFGROEPOMSCHRIJVING').forEach((item) => {
                temp[ig][item.TARIEFOMSCHRIJVING] = false
            })
        })       
        
        
        // for each item in temp look if the value contains the searchterm, if so, set the checkbox to true
        for (const [key, value] of Object.entries(temp)) {
            for (const [key2, value2] of Object.entries(value)) {
                if (key2.includes(e.target.value)){
                    temp[key][key2] = true
                }
            }
        }

        // Filter for the critical items
        if (showCritical){
            Object.keys(critical).forEach((item) => {
                for (const [key, value] of Object.entries(temp)) {
                    for (const [key2, value2] of Object.entries(value)) {
                        if (key2 in critical === false){
                            temp[key][key2] = false
                        }
                    }
                }
            })
    }
// 
        // Filter for items that have projects in the selected dates
        if (showUsedItems){
        const temp2 = []

        Object.keys(dateData).forEach((date) => {
            const currentDate = new Date(dateData[date].datum)
            currentDate.setHours(0,0,0,0)

            if (currentDate >= selectedDates.from && currentDate <= selectedDates.to) {
                if (!temp2.includes(dateData[date].tariefomschrijving)) {
                    temp2.push(dateData[date].tariefomschrijving)
                }
            }
        })

        Object.keys(temp).forEach((item) => {
            Object.keys(temp[item]).forEach((item2) => {
                if (temp2.includes(item2) === false){
                    temp[item][item2] = false
                }
            })
        })
    }


        setFiltered(temp)
    }

    const selectAllFiltered = () => {
        let temp = {}
        itemgroup.forEach((item) => {
            temp[item] = {}
            subsetData(data, item, 'TARIEFGROEPOMSCHRIJVING').forEach((item2) => {
                // check if the item is in the filtered list
                if (filtered[item][item2.TARIEFOMSCHRIJVING] === true){
                    temp[item][item2.TARIEFOMSCHRIJVING] = true
                } else {
                    temp[item][item2.TARIEFOMSCHRIJVING] = false
                }  
            })
        })
        dispatch(setItems(temp))
    }



    useEffect(() => {
        filter({target: {value: ''}})
    }, [showCritical, showUsedItems, showSearch])


    // Automatically focus the searchfield when it is opened
    const searchFieldRef = useRef()

    useEffect(() => {
        if (showSearch){
            searchFieldRef.current.focus()
        }
    }, [showSearch])

    // Control F to open the searchfield
    const handleKeyPress = useCallback((event) => {
        if (event.key === 'f' && event.ctrlKey) {
            event.preventDefault();
            setShowSearch(true)
        }
        if (event.key === 'a' && event.ctrlKey) {
            event.preventDefault();
            selectAllFiltered()
        }
      }, []);

    useEffect(() => {
        // attach the event listener
        document.addEventListener('keydown', handleKeyPress);
    
        // remove the event listener
        return () => {
          document.removeEventListener('keydown', handleKeyPress);
        };
      }, [handleKeyPress]);



    return (
        <div>
            <div style={{textAlign: 'right'}}>

                <span>
                    {showSearch ? <TextField id="standard-search" label="Search field" type="search" variant='standard' onChange={filter} inputRef={searchFieldRef}/> : null}
                </span>
                <span>
                    <Tooltip title={showSearch ? 'Sluit zoekbalk' : 'Open zoekbalk'}>
                        <IconButton onClick={  () => {setShowSearch(!showSearch)}}>
                            {showSearch ? <IndeterminateCheckBoxIcon color='primary'/> : <SearchIcon />}
                        </IconButton>
                    </Tooltip>
                </span>


                <span>
                    <Tooltip title='Toon alleen objecten met een kritieke voorraad'>
                        <IconButton onClick={() => {
                            setShowCritical(!showCritical)                
                            }}>
                            {showCritical ? <ReportIcon color='primary'/> : <ReportIcon />}
                        </IconButton>
                    </Tooltip>
                </span>

                <span>
                    <Tooltip title='Toon alleen objecten die gebruikt zijn in de geselecteerde periode'>
                        <IconButton onClick={() => {
                            setShowUsedItems(!showUsedItems)
                            }}>
                            {showUsedItems ? <UpdateIcon color='primary'/> : <UpdateIcon />}
                        </IconButton>
                    </Tooltip>
                </span>

                {/* Vertical Divider */}
                <span style={{
                      borderLeft: "2px solid",
                }}>
                </span>


                <span>
                    <Tooltip title='Selecteer alle zichtbare objecten'>
                        <IconButton onClick={() => {
                            selectAllFiltered()
                            }}>
                            <VisibilityIcon color='secondary'/>
                        </IconButton>
                    </Tooltip>
                </span>


                <span>
                <Tooltip title="Selecteer alle kritieke tarieven">
                    <IconButton
                    onClick={(e) => {
                        // set all the values that are in the critical to true and the rest to false
                        let temp = {}
                        itemgroup.forEach((item) => {
                            temp[item] = {}
                            subsetData(data, item, 'TARIEFGROEPOMSCHRIJVING').forEach((item2) => {
                                if (critical[item2.TARIEFOMSCHRIJVING] != null){
                                    temp[item][item2.TARIEFOMSCHRIJVING] = true
                                } else {
                                    temp[item][item2.TARIEFOMSCHRIJVING] = false
                                }   
                            })
                        })

                        dispatch(setItems(temp))
                    }}>
                        <ReportIcon color='warning' />
                    </IconButton>
                </Tooltip>
                </span>

                <span>
                <Tooltip title='Maak alle velden leeg'>
                        <IconButton onClick={
                            () => {
                                const ig = getUniqueValues(data, 'TARIEFGROEPOMSCHRIJVING')
                                let temp = {}
                                ig.forEach((ig) => {
                                    temp[ig] = {}
                                    subsetData(data, ig, 'TARIEFGROEPOMSCHRIJVING').forEach((item) => {
                                        temp[ig][item.TARIEFOMSCHRIJVING] = false
                                    })
                                })

                                let temp2 = {}
                                ig.forEach((ig) => {
                                    temp2[ig] = false
                                })
                                
                                dispatch(setItems(temp))
                                dispatch(setItemGroups(temp2))
                            }
                        }>
                            <CancelIcon color='error' />
                        </IconButton>
                    </Tooltip>
                </span>
            </div>



            <Divider />
            {itemgroup.map((itemgroup, index) => (
                <div key={index}>
                <FormControlLabel
                    label={<div><b>{itemgroup}</b> </div>}
                    control={
                    <Checkbox
                        checked={ groupChecked[itemgroup] }
                        // onchange is a function that sets all the values of the itemgroup to true or false
                        onChange= {
                            (event) => {
                                dispatch(setItemGroups({ ...groupChecked, [itemgroup]: event.target.checked }))
                                    let temp = {}
                                    if (event.target.checked){
                                        subsetData(data, itemgroup, 'TARIEFGROEPOMSCHRIJVING').forEach((item) => {
                                            // if the item is in the filtered list, set it to true, else set it to false
                                            if (filtered[itemgroup][item.TARIEFOMSCHRIJVING] === true){
                                                temp[item.TARIEFOMSCHRIJVING] = true
                                            } else {
                                                temp[item.TARIEFOMSCHRIJVING] = false
                                            }
                                        })
                                    } else {
                                        subsetData(data, itemgroup, 'TARIEFGROEPOMSCHRIJVING').forEach((item) => {
                                            temp[item.TARIEFOMSCHRIJVING] = false
                                        })
                                    }
                                dispatch(setItems({ ...checkboxStates, [itemgroup]: temp }))
                            }
                        }
                    
                        inputProps={{ 'aria-label': 'controlled' }}
                    />
                }
            />
            <span>
                <Tooltip 
                title= 
                {showSubgroup[index] ? `Sluit ${itemgroup}` : `Laat ${itemgroup} zien` }
                >
                <IconButton onClick={() => 
                    setShowSubgroup(showSubgroup.map((item, i) => {
                        if (i === index) {
                            return !item
                        } else {
                            return item
                        }
                    }))
                }>
                    {showSubgroup[index] ? <IndeterminateCheckBoxIcon /> : <AddBoxIcon color='primary' /> }
                </IconButton>
                </Tooltip>
            </span>
            <div style={
                        showSubgroup[index] ? subgroupStyle :
                        {
                        marginLeft: "30px",
                        display: 'none',
                        }}>
                
            {
                subsetData(data, itemgroup, 'TARIEFGROEPOMSCHRIJVING').map((item, index) => (
                    <div key={index} style={{marginLeft: '30px'}}>

                        {/* if showCritical is true, only show the items that are also in critical */}
                                <div key={item.TARIEFOMSCHRIJVING}>
                                {filtered[itemgroup][item.TARIEFOMSCHRIJVING] ?
                                    <FormControlLabel
                                        label={item.TARIEFOMSCHRIJVING}
                                        control={
                                        <Checkbox
                                            checked={ checkboxStates[itemgroup][item.TARIEFOMSCHRIJVING] }
                                            onChange= {
                                                (event) => {
                                                    dispatch(setItems({ ...checkboxStates, [itemgroup]: { ...checkboxStates[itemgroup], [item.TARIEFOMSCHRIJVING]: event.target.checked } }))
                                                }
                                            }
                                            inputProps={{ 'aria-label': 'controlled' }}
                                        />
                                        }
                                    />
                            : null
                            }
                            </div>  
                    </div>
                ))
            }
            </div>
            </div>
            ))
            }
            
        </div>
    )
    }

export default ChooseFields